import { defineQuery } from 'bitecs';
import { Health, Player, Hunger, Thirst, Wetness } from '../world.js';
import { PLAYER_STATS } from '../config.js';

const playerQuery = defineQuery([Health, Player]);

// Health system constants
const HEALTH_REGEN_RATE = 0.1; // Health points per tick
const STARVATION_DAMAGE = 1.0; // Damage per tick when starving (increased from 0.5)
const DEHYDRATION_DAMAGE = 0.5; // Damage per tick when dehydrated
const HYPOTHERMIA_DAMAGE = 0.5; // Damage per tick when too wet and cold

export function healthSystem(world) {
    const players = playerQuery(world);
    
    for (const player of players) {
        const currentHealth = Health.value[player];
        
        // Check for damage sources
        let damage = 0;
        
        // Starvation damage
        if (Hunger.value[player] === PLAYER_STATS.MIN_HUNGER) {
            damage += PLAYER_STATS.HUNGER_DAMAGE_RATE;
        }
        
        // Dehydration damage
        if (Thirst.value[player] === PLAYER_STATS.MIN_THIRST) {
            damage += PLAYER_STATS.THIRST_DAMAGE_RATE;
        }
        
        // Hypothermia damage (when wet and cold)
        if (Wetness.value[player] > PLAYER_STATS.MAX_WETNESS * 0.8) {
            damage += PLAYER_STATS.HUNGER_DAMAGE_RATE; // Using hunger damage rate for hypothermia
        }
        
        // Apply damage
        if (damage > 0) {
            Health.value[player] = Math.max(PLAYER_STATS.MIN_HEALTH, currentHealth - damage);
        } else {
            // Regenerate health when not taking damage
            Health.value[player] = Math.min(PLAYER_STATS.MAX_HEALTH, currentHealth + PLAYER_STATS.HEALTH_RECOVERY_RATE);
        }
        
        // Check for death
        if (Health.value[player] === PLAYER_STATS.MIN_HEALTH && !world.isGameOver) {
            world.isGameOver = true;
            // Dispatch game over event
            window.dispatchEvent(new CustomEvent('gameOver'));
        }
    }
    
    return world;
} 